(function() {
	"use strict";

	var DOM = BS.DOM;

	BS.DOMReady(initMobileMenu);
	
	function initMobileMenu() {
		var opened = false,
		$body = DOM.q("body"),
		$menu = DOM.q(".hd-nav");

		closeMobileMenu();

		$body.addEventListener("click", toggleMobileMenu);

		setTimeout(function() {
			$body.classList.add("animated");
		}, 100);

		function toggleMobileMenu(event) {
			if (opened) {
				if (!DOM.closest($menu, event.target)) {
					closeMobileMenu();
					event.preventDefault();
				}
			} else {
				if (DOM.closest(".g-nav-toggle", event.target)) {
					openMobileMenu();
				}
			}
		}

		function openMobileMenu() {
			$body.classList.add("g-nav-on");
			opened = true;
		}

		function closeMobileMenu() {
			$body.classList.remove("g-nav-on");
			opened = false;
		}
	}
	
})();
